import React from 'react'
import { Select, Tabs, DatePicker, Steps } from 'antd'
import { ajaxApi} from '@/server/index'
import {getParmUrl} from '@/public/utils'
import 'moment/locale/zh-cn'
import common from '@/public/common'
import BasicInformation from './basic-information'
import CooperationPolicy from './cooperation-policy'
const Option = Select.Option
const TabPane = Tabs.TabPane
const { RangePicker } = DatePicker
const { Step } = Steps
class NonMedicalDevices extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      current: 0,
      postData: {
        item_id: ''
      }
    }
  }

  componentDidMount () {
    let {postData} = this.state
    if (getParmUrl('id')) {
      postData.item_id = getParmUrl('id')
      this.setState({
        postData
      }, () => {
        this.getBasicDetails()
      })
    }
  }

  // 获取详情
  getBasicDetails = async () => {
    let {postData, detailsData} = this.state
    try {
      let res = await ajaxApi({
        url:common.scpUrl + 'item/query-detail',
        // url: 'http://192.168.10.220:8120/item/query-detail',
        params: postData
      })
      if (res.status === 200 && res.data) {
        sessionStorage.setItem('onMedicalCareData', JSON.stringify(res.data))
        this.setState({
          detailsData: res.data
        })
      }
    } catch (e) {
      console.log(e)
    }
  }

  // 获取步骤条的参数
  getCurrent =(value) => {
    this.setState({
      current: value
    })
  }

  render () {
    return (
      <div className="addGood">
        <div className="search">
          <div style={{width: '70%', margin: '0 auto'}}>
            <Steps current={this.state.current}>
              <Step title="步骤1" description="填写商品基本信息" />
              <Step title="步骤2" description="填写合作政策" />
            </Steps>
          </div>

          <div style={{width: '100%', margin: '0 auto', marginTop: '24px'}}>
            {this.state.current === 0 ? <BasicInformation history={this.props.history} getCurrent ={this.getCurrent}/> : <CooperationPolicy history={this.props.history} getCurrent ={this.getCurrent}/>}
          </div>
        </div>
      </div>
    )
  }
}
export default NonMedicalDevices



// WEBPACK FOOTER //
// ./src/pages/commoditymanagement/addcompleteinformation/nonmedicaldevices/no-nmedical-devices.js